<script lang="ts">
    export let value: string = '';
    export let disabled: boolean = false;
    export let style: string = '';
    export let className: string = '';
    export let autofocus: boolean = false;
    export let valid: boolean = true;
    export let step: string = '1';
    export let min: string="0";
    export let max: string|null = null;
</script>

<input class="input-small {className}" {step} {min} {max} type="number" class:invalid-input={!valid}
    bind:value={value}
    disabled={disabled}
    style={style}
    on:keydown
    on:keyup
    on:keypress
    on:change
    on:input
    {autofocus}
/>

<style>
    .input-small {
        /*padding: 4px;*/
        /*padding: 7px;*/
        /*border: 1px solid #ccc;*/
        /*border: 0;*/
        /*border-radius: 5px;*/
        /*min-width: 188px;*/
        outline: 0;
        max-width: 60px;
        /*color: var(--automapa-blue);*/
        text-align: center;
        /*font-weight: 600;*/
        padding: var(--input-small-padding);
        border: var(--input-small-border);
        color: var(--input-small-color);
        border-radius: var(--input-small-border-radius);
    }
    .input-error {
        border-color: var(--automapa-red);
    }
</style>
